import { IResourceComponentsProps, useForm } from "@refinedev/core";
import { AntdEditInferencer } from "@refinedev/inferencer/antd";
import Cw8EditWrapper from "components/cw8/Cw8EditWrapper";
import { ChildForm } from "interfaces/schemaDB";

export const FragmentObjectsEdit: React.FC<IResourceComponentsProps> = () => {
  // return <AntdEditInferencer />;

  const resourceLabel :string = 'FragmentObject';
  const resourceName :string = 'fragmentObject';
  const { id } = useForm();
  const childrenForms : ChildForm[] =[
    
  ]

  return(
    <Cw8EditWrapper
      resourceLabel = {resourceLabel}
      resourceName = {resourceName}
      id = {id}
      childrenForms = {childrenForms}
    ></Cw8EditWrapper>
  )  
};
